import {
  closeMaintenance,
  closeMaintenanceDoc,
  deleteMaintenanceWarning,
  downloadMaintenance,
  getChild,
  getClientList,
  getCountTratativas,
  getDocInfosByNC,
  getGestaoIssuesList,
  getGroupSystemMaintenanceOpen,
  getHeadquarters,
  getMaintenanceAll,
  getMaintenanceDoc,
  getQuantTratativasOp,
  getSupervisaoMaintenance,
  getSystemTypes,
  getWarningList,
  listClientActiveSystemsTypes,
  listClientAddresses,
  listDocumentTypes,
  listInspectionTypes,
  listMaintenanceTypes,
  listOperators,
  listOrganizationClients,
  listOrganizations,
  loadClientDocument,
  loadClientEvent,
  loadClientPanel,
  loadMaintenance,
  saveDocument,
  saveMaintenance,
  sendMailResolvedNC,
  setMaintenanceDoc,
  setMaintenanceEvent,
  setMaintenanceWarning,
} from './Gestao';
import { checkLogin } from './Login';

const baseApi = process.env.REACT_APP_API_URL;
const auth = process.env.REACT_APP_BEARER;

export {
  baseApi,
  auth,
  checkLogin,
  getGestaoIssuesList,
  listOrganizationClients,
  setMaintenanceWarning,
  getWarningList,
  closeMaintenance,
  loadClientPanel,
  loadClientDocument,
  loadClientEvent,
  loadMaintenance,
  getMaintenanceDoc,
  getChild,
  listClientActiveSystemsTypes,
  saveMaintenance,
  setMaintenanceDoc,
  setMaintenanceEvent,
  listDocumentTypes,
  getDocInfosByNC,
  closeMaintenanceDoc,
  saveDocument,
  listClientAddresses,
  listOrganizations,
  listMaintenanceTypes,
  getClientList,
  getQuantTratativasOp,
  getCountTratativas,
  getSupervisaoMaintenance,
  downloadMaintenance,
  deleteMaintenanceWarning,
  getHeadquarters,
  getSystemTypes,
  getMaintenanceAll,
  sendMailResolvedNC,
  getGroupSystemMaintenanceOpen,
  listOperators,
  listInspectionTypes,
};
